<div class="top-margin-15"></div>
<div class="row nova-font-style">
  <div class="col s12 m12 l12 xl12 remove-default-padding">
    <div [hidden]="initialLoading">
      <div>
        <kendo-tabstrip #hometabstrip [animate]="true" [tabAlignment]="'justify'">
          <kendo-tabstrip-tab title="News" [selected]="true" *ngIf="showNews">
            <ng-template kendoTabContent>
              <div *ngIf="showNews">
                <app-news></app-news>
              </div>
            </ng-template>
          </kendo-tabstrip-tab>
          <kendo-tabstrip-tab title="Secure Messages" [selected]="!showNews ? true : false" *ngIf="showMessages">
            <ng-template kendoTabContent>
              <div *ngIf="showMessages">
                <app-messages></app-messages>
              </div>
            </ng-template>
          </kendo-tabstrip-tab>
          <kendo-tabstrip-tab title="Task Tracker" [selected]="(!showNews && !showMessages) ? true : false" *ngIf="showTracker">
            <ng-template kendoTabContent>
              <div *ngIf="showTracker">
                <app-task-tracker></app-task-tracker>
              </div>
            </ng-template>
          </kendo-tabstrip-tab>
        </kendo-tabstrip>
      </div>
    </div>
  </div>
</div>
